import { Stack, Typography, useTheme } from "@mui/material";
import { Check, Star } from "lucide-react";
import type { FC } from "react";
import { InitialsAvatar } from "web_myplann/Shared/Components/InitialsAvatar";

type Props = {
	name: string;
	photo?: string;
	isMain: boolean;
	isSelected: boolean;
	onClick: () => void;
};

export const AdvisorPickerRow: FC<Props> = ({
	name,
	photo,
	isMain,
	isSelected,
	onClick,
}) => {
	const theme = useTheme();

	return (
		<Stack
			direction="row"
			alignItems="center"
			gap={1.2}
			px={1.6}
			py={1.2}
			onClick={onClick}
			bgcolor={isSelected ? theme.palette.blue[50] : "transparent"}
			sx={{ cursor: "pointer" }}
		>
			<InitialsAvatar name={name} photo={photo} size={44} />
			<Stack
				direction="row"
				alignItems="center"
				gap={0.6}
				flex={1}
				minWidth={0}
			>
				<Typography variant="bodyStrong" noWrap>
					{name}
				</Typography>
				{isMain && (
					<Star
						size={12}
						fill={theme.palette.amber[400]}
						color={theme.palette.amber[400]}
					/>
				)}
			</Stack>
			{isSelected && (
				<Check size={theme.iconSize.md} color={theme.palette.blue[500]} />
			)}
		</Stack>
	);
};
